export default class Scope {}

Scope.VetsterPlusEligible = 'vetster_plus_eligible';
